import { default as callbackrfS2A3KLl7Meta } from "/usr/src/app/pages/callback.vue?macro=true";
import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as loginRGcvZC480vMeta } from "/usr/src/app/pages/login.vue?macro=true";
import { default as logoutLM6hK8aOwEMeta } from "/usr/src/app/pages/logout.vue?macro=true";
import { default as payment_45successs25XD3uQ7NMeta } from "/usr/src/app/pages/payment-success.vue?macro=true";
import { default as indexDFBeEKKS8RMeta } from "/usr/src/app/pages/payment/[id]/contract/index.vue?macro=true";
import { default as index1W7McouxnyMeta } from "/usr/src/app/pages/payment/[id]/index.vue?macro=true";
import { default as starttBrk3YoRz7Meta } from "/usr/src/app/pages/payment/[id]/start.vue?macro=true";
import { default as test_45shortITG90oqgVIMeta } from "/usr/src/app/pages/payment/test-short.vue?macro=true";
import { default as testEHRF2mOnOTMeta } from "/usr/src/app/pages/payment/test.vue?macro=true";
import { default as formkitGTSr2iEFaZMeta } from "/usr/src/app/pages/test/formkit.vue?macro=true";
import { default as image7ypFD70G9mMeta } from "/usr/src/app/pages/test/image.vue?macro=true";
export default [
  {
    name: "callback",
    path: "/callback",
    component: () => import("/usr/src/app/pages/callback.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexgw2ikJsyhcMeta || {},
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/usr/src/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/usr/src/app/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: "payment-success",
    path: "/payment-success",
    component: () => import("/usr/src/app/pages/payment-success.vue").then(m => m.default || m)
  },
  {
    name: "payment-id-contract",
    path: "/payment/:id()/contract",
    component: () => import("/usr/src/app/pages/payment/[id]/contract/index.vue").then(m => m.default || m)
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    meta: index1W7McouxnyMeta || {},
    component: () => import("/usr/src/app/pages/payment/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "payment-id-start",
    path: "/payment/:id()/start",
    component: () => import("/usr/src/app/pages/payment/[id]/start.vue").then(m => m.default || m)
  },
  {
    name: "payment-test-short",
    path: "/payment/test-short",
    component: () => import("/usr/src/app/pages/payment/test-short.vue").then(m => m.default || m)
  },
  {
    name: "payment-test",
    path: "/payment/test",
    component: () => import("/usr/src/app/pages/payment/test.vue").then(m => m.default || m)
  },
  {
    name: "test-formkit",
    path: "/test/formkit",
    meta: formkitGTSr2iEFaZMeta || {},
    component: () => import("/usr/src/app/pages/test/formkit.vue").then(m => m.default || m)
  },
  {
    name: "test-image",
    path: "/test/image",
    component: () => import("/usr/src/app/pages/test/image.vue").then(m => m.default || m)
  }
]